import { ReactElement } from 'react';
import { userService } from 'common/services/user.service';
import { RetailerType } from 'common/constants/entities';
import { NonTargetHistory } from './non-target-history';
import { TargetHistoryTabs } from './target-history-tabs';

interface Props {
  pid: string;
  open: boolean;
}

export function PdpHistoryTabs({ pid, open }: Props): ReactElement {
  const isTarget = userService.ensureRetailer(RetailerType.Target);

  if (isTarget) {
    return <TargetHistoryTabs pid={pid} />;
  }

  return <NonTargetHistory pid={pid} open={open} />;
}
